import { useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, FileSpreadsheet } from "lucide-react";

const SHEETS = ["Customers", "Leads", "Mela", "Attendance", "Followups", "Applications"];

export default function ExportData() {
  const [loading, setLoading] = useState(false);
  const doExport = async () => {
    setLoading(true);
    try {
      const res = await api.get("/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = "digiloans_export.xlsx"; a.click();
      URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (e) { toast.error("Export failed"); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <PageHeader title="Excel Export" subtitle="Download a complete multi-sheet report of your CRM." />
      <Card className="p-8 max-w-2xl">
        <div className="w-14 h-14 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-5"><FileSpreadsheet size={28} /></div>
        <h3 className="text-xl font-bold text-slate-900">One-click full export</h3>
        <p className="text-sm text-slate-500 mt-1 mb-5">The workbook includes a dedicated sheet for each dataset below.</p>
        <div className="flex flex-wrap gap-2 mb-6">
          {SHEETS.map((s) => <span key={s} className="px-3 py-1.5 rounded-full bg-slate-100 text-slate-600 text-sm font-medium" data-testid={`sheet-${s}`}>{s}</span>)}
        </div>
        <Button onClick={doExport} disabled={loading} data-testid="export-btn" className="bg-emerald-600 hover:bg-emerald-700 h-11"><Download size={18} className="mr-2" />{loading ? "Preparing…" : "Download Excel Report"}</Button>
      </Card>
    </div>
  );
}
